if (!customElements.get('dut-related-products-carousel')) {
  customElements.define('dut-related-products-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.previous = this.querySelector('[data-carousel-previous]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      new ResizeObserver(() => this.update()).observe(this.track);
      this.update();
    }

    move(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    update() {
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      const media = this.track.querySelector('.card__inner');
      if (media) {
        const bounds = media.getBoundingClientRect();
        const top = bounds.top - this.getBoundingClientRect().top + bounds.height / 2;
        this.style.setProperty('--carousel-arrow-top', `${top}px`);
      }
    }
  });
}
